import { render, staticRenderFns } from "./ModalTransferDetails.vue?vue&type=template&id=277ccd73"
import script from "./ModalTransferDetails.vue?vue&type=script&lang=js"
export * from "./ModalTransferDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports